import { createTheme } from "@mui/material/styles";

export default function CstmMui() {
  const prop = {
    primary: "#00E396",
    primaryDark: "#01c282",
    primaryTXS: "rgb(2 165 155 / 10%)",
    primaryTSM: "rgb(2 165 155 / 15%)",
    primaryTMD: "rgb(2 165 155 / 30%)",
    error: "#ff0000",
    warning: "#FFCC00",
    info: "#00e1ff",
    white: "#fff",
    whitexs: "rgb(145 145 145 / 6%)",
    whitesm: "#dbdbdb38",
    whitemd: "#D1D5DB",
    deepDark: "#464646",
    darkBlur: "#111827",
    gray: "#7a7a7a",
    xs: "0px 19px 60px rgb(0 0 0 / 5%)",
    radius: "0.6rem",
  };
  const theme = createTheme({
    status: {
      danger: prop.danger,
    },
    palette: {
      default: {
        contrastText: prop.deepDark,
      },
      primary: {
        main: prop.primary,
        contrastText: prop.white,
      },
      trans: {
        main: prop.primaryTXS,
        contrastText: prop.primaryDark,
      },
      whitesm: {
        main: prop.whitesm,
        contrastText: prop.primary,
      },
      secondary: {
        main: prop.darkBlur,
        contrastText: prop.whitemd,
      },
      white: {
        main: prop.white,
        contrastText: prop.gray,
      },
      whitemd: {
        main: prop.whitemd,
        contrastText: "#00d75d",
      },
      dark: {
        main: prop.darkBlur,
        contrastText: prop.whitemd,
      },
      error: {
        main: prop.error,
        contrastText: prop.white,
      },
      warning: {
        main: prop.warning,
        contrastText: prop.white,
      },
      info: {
        main: prop.info,
        contrastText: prop.white,
      },
      success: {
        main: prop.primary,
        contrastText: prop.white,
      },
    },
    components: {
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: prop.radius,
            "&:hover fieldset": {
              borderColor: `${prop.primary} !important`,
            },
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: prop.radius,
            paddingLeft: "10px",
            paddingRight: "10px",
          },
        },
      },
      MuiFilledInput: {
        styleOverrides: {
          root: {
            "&, &:hover, &.MuiFilledInput-root.Mui-focused": {
              backgroundColor: "rgb(145 145 145 / 6%)",
              borderTopLeftRadius: "10px",
              borderTopRightRadius: "10px",
            },
            " &.MuiFilledInput-root:before": {
              borderBottom: "1px solid #D1D5DB",
            },
          },
        },
      },
    },
  });
  return {
    theme,
  };
}
